<template>
  <div class="modal custom-database-settings-wrapper">
    <div class="pull-right">
      <div class="btn-close" @click="close"></div>
    </div>
    <div class="content" v-bind:class="{ stretch: detailsIsVisible }">
      <div class="tab overview">
        <h2 class="name database-setting-title">
          {{ appSettings.settings.title }}
        </h2>

        <div
          v-if="customHighlightedItems.length"
          class="highlighted-item-filter"
        >
          <div class="search-box">
            <input
              type="text"
              name="search"
              v-model="search"
              placeholder="Suchen..."
            />
          </div>

          <div class="filter-item">
            <div>
              <h2>Angezeigt in der Übersicht</h2>
              <div
                ref="customSettingSelectedItems"
                class="filter-item-dropdown fancy-scroll"
                id="selected"
                @scroll.passive="showScrollbar"
              >
                <div
                  class="dropzone-line"
                  v-for="(item, itemIndex) in getHighlightedItems"
                  :id="`selected-${itemIndex}`"
                  :key="itemIndex"
                  @mousedown="moveStart($event, item, `selected-${itemIndex}`)"
                >
                  <span
                    class="horizontal-hidden-top-line"
                    :class="{
                      dragActive:
                        activeDragOverIdx < currentDraggingItemIndex &&
                        `${databaseDraggingObject.mouseMovingArea}-${activeDragOverIdx}` ==
                          `selected-${itemIndex}`,
                    }"
                    :id="itemIndex"
                  ></span>
                  <div class="drag-icon">
                    <i class="fas fa-bars"></i>
                  </div>
                  <div class="custom-checklist">
                    <input type="checkbox" v-model="item.selected" />
                    <label class="custom-checkbox-label" for="items"
                      >{{ item.label }}
                      <span
                        class="eye-icon"
                        @click.prevent="setItemHighlight(itemIndex)"
                      >
                        <i class="fa fa-eye"></i>
                      </span>
                    </label>
                  </div>
                  <span
                    class="horizontal-hidden-bottom-line"
                    :class="{
                      dragActive:
                        activeDragOverIdx == selectedItemsLength
                          ? activeDragOverIdx == itemIndex + 1 &&
                            databaseDraggingObject.mouseMovingArea !=
                              'disselected'
                          : activeDragOverIdx > currentDraggingItemIndex &&
                            `${databaseDraggingObject.mouseMovingArea}-${activeDragOverIdx}` ==
                              `selected-${itemIndex + 1}`,
                    }"
                    :id="itemIndex + 1"
                  ></span>
                </div>
              </div>
            </div>
            <div>
              <h2>Versteckt in der Übersicht</h2>
              <div
                ref="customSettingDisselectedItems"
                class="filter-item-dropdown fancy-scroll"
                id="disselected"
                @scroll.passive="showScrollbar"
              >
                <div
                  :id="`disselected-${getUnhighlightedItemIndex(itemIndex)}`"
                  class="dropzone-line"
                  v-for="(item, itemIndex) in getUnhighlightedItems"
                  :key="itemIndex"
                  @mousedown="
                    moveStart(
                      $event,
                      item,
                      `disselected-${getUnhighlightedItemIndex(itemIndex)}`
                    )
                  "
                >
                  <!-- :class="{
                      dragActive:
                        activeDragOverIdx < currentDraggingItemIndex &&
                        `${databaseDraggingObject.mouseMovingArea}-${activeDragOverIdx}` ==
                          `disselected-${getUnhighlightedItemIndex(
                            itemIndex
                          )}` &&
                        databaseDraggingObject.mouseMovingArea != 'selected',
                    }" -->
                  <span
                    class="horizontal-hidden-top-line"
                    :id="getUnhighlightedItemIndex(itemIndex)"
                  ></span>
                  <div class="drag-icon">
                    <i class="fas fa-bars"></i>
                  </div>
                  <div class="custom-checklist">
                    <input type="checkbox" v-model="item.selected" />
                    <label class="custom-checkbox-label" for="items"
                      >{{ item.label }}
                      <span
                        class="eye-icon"
                        @click.prevent="
                          setItemHighlight(getUnhighlightedItemIndex(itemIndex))
                        "
                      >
                        <i class="fa fa-eye-slash"></i> </span
                    ></label>
                  </div>
                  <span
                    class="horizontal-hidden-bottom-line"
                    :id="getUnhighlightedItemIndex(itemIndex)"
                  ></span>
                  <!-- :class="{
                      dragActive:
                        activeDragOverIdx > currentDraggingItemIndex &&
                        `${databaseDraggingObject.mouseMovingArea}-${activeDragOverIdx}` ==
                          `disselected-${getUnhighlightedItemIndex(itemIndex)}`,
                    }" -->
                </div>
              </div>
            </div>
          </div>
          <div v-if="detailsIsVisible" class="tab details">
            <h2 class="name" @click="hideDetails()">
              {{ selectedItem.caption }}
            </h2>
            <div class="block">
              <span v-html="selectedItem.description"></span>
              <span
                v-if="'more' in selectedItem && !more"
                @click="more = true"
                class="link"
                ><br />Mehr anzeigen <i class="fas fa-sort-down"></i
              ></span>
              <span v-if="more" v-html="selectedItem.more"></span>
              <span v-if="more" @click="more = false" class="link"
                ><br />Weniger anzeigen. <i class="fas fa-sort-up"></i
              ></span>
            </div>
            <div class="block">
              <h3 class="name">Optionen</h3>
              <div class="list">
                <input
                  v-if="!isChoice(selectedItem.input)"
                  v-bind:type="selectedItem.input.type"
                  v-model="selectedItem.value"
                />
                <div v-if="isChoice(selectedItem.input)" class="radio-wrapper">
                  <div
                    v-for="(o, i) in selectedItem.input.options"
                    v-bind:key="i"
                    class="item"
                    @click="setTrue(o)"
                  >
                    <label class="key">{{ o.label }}</label>
                    <div class="radioOption value">
                      <input
                        v-bind:type="selectedItem.input.type"
                        v-bind:value="o.label"
                        v-bind:checked="o.checked"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="block">
          <a @click="setDefaultValues">Anzeige zurücksetzen</a>
        </div> -->
      </div>
      <div v-if="detailsIsVisible" class="tab details">
        <h2 class="name" @click="hideDetails()">{{ selectedItem.caption }}</h2>
        <div class="block">
          <span v-html="selectedItem.description"></span>
          <span
            v-if="'more' in selectedItem && !more"
            @click="more = true"
            class="link"
            ><br />Mehr anzeigen <i class="fas fa-sort-down"></i
          ></span>
          <span v-if="more" v-html="selectedItem.more"></span>
          <span v-if="more" @click="more = false" class="link"
            ><br />Weniger anzeigen. <i class="fas fa-sort-up"></i
          ></span>
        </div>
        <div class="block">
          <h3 class="name">Optionen</h3>
          <div class="list">
            <input
              v-if="!isChoice(selectedItem.input)"
              v-bind:type="selectedItem.input.type"
              v-model="selectedItem.value"
            />
            <div v-if="isChoice(selectedItem.input)" class="radio-wrapper">
              <div
                v-for="(o, i) in selectedItem.input.options"
                v-bind:key="i"
                class="item"
                @click="setTrue(o)"
              >
                <label class="key">{{ o.label }}</label>
                <div class="radioOption value">
                  <input
                    v-bind:type="selectedItem.input.type"
                    v-bind:value="o.label"
                    v-bind:checked="o.checked"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Store from '../store/store';
import { debouncer } from '../utils/helpers';

export default {
  name: 'CustomDatabaseSettings',
  data() {
    return {
      detailsIsVisible: false,
      selectedItem: {
        caption: '',
        description: '',
      },
      more: false,
      operation: null,
      search: '',
      searchActive: false,
      activeDragOverIdx: null,
      currentDraggingItemIndex: null,
      databaseDraggingObject: {
        isDraggingDatabase: false,
        parent: null,
        parentRect: null,
        scrollContainer: null,
        draggable: null,
        draggingArea1Details: {
          rectDetails: {},
          horizontalTopTargetLineArray: [],
          horizontalBottomTargetLineArray: [],
        },
        draggingArea2Details: {
          rectDetails: {},
          horizontalTopTargetLineArray: [],
          horizontalBottomTargetLineArray: [],
        },
        scrollSpeed: 12,
        scrollInterval: null,
        selectedArea: null,
        mouseMovingDirection: undefined,
      },
    };
  },
  props: {
    customHighlightedItems: {
      type: Array,
      default() {
        return [];
      },
    },
    dataSchema: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  methods: {
    close: function () {
      this.detailsIsVisible = false;
      this.$emit('close');
    },
    showDetails: function (item) {
      this.selectedItem = item;
      this.detailsIsVisible = true;
    },
    hideDetails: function () {
      this.more = false;
      this.detailsIsVisible = false;
    },
    isChoice: function (e) {
      return e.type == 'checkbox' || e.type == 'radio';
    },
    setTrue: function (option) {
      this.selectedItem.input.options
        .filter((e) => e != option)
        .forEach((e) => {
          e.checked = false;
        });
      option.checked = true;
      this.selectedItem.value = option.value;
    },
    async setDefaultValues() {
      if (this.customHighlightedItems.length) {
        await this.$emit('setHighlightItemOptions');
      } else {
        localStorage.removeItem(this.user.username + '.userSettings');
        this.$store.dispatch('getUserSettings');
      }
    },
    async setItemHighlight(clickedIndex) {
      await this.$emit('setItemHighlight', this.settingJson[clickedIndex]);
    },
    getUnhighlightedItemIndex(currentIndex) {
      // to get index with sum of highlighted items
      return this.getHighlightedItems.length + currentIndex;
    },
    moveStart(e, item, id) {
      const splitedId = id.split('-');
      this.databaseDraggingObject.draggingArea1Details.horizontalTopTargetLineArray =
        this.$refs.customSettingSelectedItems.querySelectorAll(
          '.horizontal-hidden-top-line'
        );
      this.databaseDraggingObject.draggingArea1Details.horizontalBottomTargetLineArray =
        this.$refs.customSettingSelectedItems.querySelectorAll(
          '.horizontal-hidden-bottom-line'
        );
      //code for the feature drag and drop in bottom unhighlighted items
      this.databaseDraggingObject.draggingArea2Details.horizontalTopTargetLineArray =
        this.$refs.customSettingDisselectedItems.querySelectorAll(
          '.horizontal-hidden-top-line'
        );
      this.databaseDraggingObject.draggingArea2Details.horizontalBottomTargetLineArray =
        this.$refs.customSettingDisselectedItems.querySelectorAll(
          '.horizontal-hidden-bottom-line'
        );
      this.currentDraggingItemIndex = Number(splitedId[1]);
      this.databaseDraggingObject.selectedArea = splitedId[0];
      e.preventDefault();
      document.body.style.cursor = 'grabbing';
      this.databaseDraggingObject.isDraggingDatabase = true;
      this.databaseDraggingObject.startingPosition = e.clientY;
      this.$store.commit(
        'SET_DATABASE_DRAGGING',
        this.databaseDraggingObject.isDraggingDatabase
      );
      this.databaseDraggingObject.parent =
        document.querySelector('.filter-item');
      this.databaseDraggingObject.parentRect =
        this.databaseDraggingObject.parent.getBoundingClientRect();
      const draggableElement = document.getElementById(id);
      this.databaseDraggingObject.draggable = draggableElement.cloneNode(true);

      this.databaseDraggingObject.draggable.style.position = 'absolute';
      this.databaseDraggingObject.draggable.style.zIndex = -1;
      this.databaseDraggingObject.draggable.style.opacity = -1;
      this.databaseDraggingObject.draggable.style.width = 'calc(100% - 63px)';
      this.databaseDraggingObject.draggable.style.background = 'transparent';
      document.body.style.overflow = 'hidden';
      draggableElement.parentNode.insertBefore(
        this.databaseDraggingObject.draggable,
        draggableElement
      );
      this.databaseDraggingObject.draggableRect =
        this.databaseDraggingObject.draggable.getBoundingClientRect();
      this.activeDragOverIdx = null;
      window.addEventListener('mouseup', this.onMouseEnd);
      document
        .getElementById('app')
        .addEventListener('mousemove', this.onMouseMoving);
    },
    onMouseEnd() {
      document.body.style.cursor = 'auto';
      this.databaseDraggingObject.scrollInterval = clearInterval(
        this.databaseDraggingObject.scrollInterval
      );
      this.databaseDraggingObject.scrollInterval = null;
      this.databaseDraggingObject.draggable.remove();
      this.databaseDraggingObject.isDraggingDatabase = false;
      this.$store.commit(
        'SET_DATABASE_DRAGGING',
        this.databaseDraggingObject.isDraggingDatabase
      );
      if (
        this.currentDraggingItemIndex != null &&
        this.activeDragOverIdx != null &&
        (this.currentDraggingItemIndex !== this.activeDragOverIdx ||
          this.activeDragOverIdx == this.selectedItemsLength) &&
        this.databaseDraggingObject.mouseMovingArea &&
        (this.databaseDraggingObject.mouseMovingArea != 'disselected' ||
          this.databaseDraggingObject.selectedArea != 'disselected')
      ) {
        let activeDropZoneIndex = this.activeDragOverIdx;
        if (
          this.currentDraggingItemIndex < activeDropZoneIndex &&
          this.databaseDraggingObject.mouseMovingArea == 'selected' &&
          this.databaseDraggingObject.selectedArea == 'selected'
        )
          activeDropZoneIndex = activeDropZoneIndex - 1;
        this.$emit(
          'setItemHighlightOnDrop',
          this.settingJson[this.currentDraggingItemIndex],
          this.settingJson[
            activeDropZoneIndex == this.selectedItemsLength &&
            this.databaseDraggingObject.mouseMovingArea != 'disselected'
              ? activeDropZoneIndex - 1
              : activeDropZoneIndex
          ],
          activeDropZoneIndex == this.selectedItemsLength ? true : false
        );
      }
      // for the no disselcted and dragging from selected to disselecter

      if (
        this.activeDragOverIdx === null &&
        !this.getUnhighlightedItems?.length &&
        this.databaseDraggingObject.mouseMovingArea == 'disselected' &&
        this.databaseDraggingObject.selectedArea != 'disselected'
      ) {
        this.$emit(
          'setItemHighlight',
          this.settingJson[this.currentDraggingItemIndex]
        );
      }
      document.body.style.overflow = 'unset';

      this.currentDraggingItemIndex = null;
      this.activeDragOverIdx = null;

      window.removeEventListener('mouseup', this.onMouseEnd);
      document
        .getElementById('app')
        .removeEventListener('mousemove', this.onMouseMoving);
    },
    onMouseMoving(e) {
      e.preventDefault();
      if (e.clientY < this.databaseDraggingObject.draggableRect.top) {
        this.databaseDraggingObject.mouseMovingDirection = 'up';
      }
      if (e.clientY > this.databaseDraggingObject.draggableRect.top) {
        this.databaseDraggingObject.mouseMovingDirection = 'down';
      }

      const isMovingAllow =
        e.clientY >=
          this.databaseDraggingObject.draggingArea1Details.rectDetails.top -
            5 &&
        e.clientY <
          this.databaseDraggingObject.draggingArea2Details.rectDetails.bottom -
            30;
      if (isMovingAllow) {
        this.databaseDraggingObject.draggable.style.top = `${e.clientY}px`;
        this.databaseDraggingObject.draggableRect =
          this.databaseDraggingObject.draggable.getBoundingClientRect();
        this.databaseDraggingObject.mouseMovingArea =
          this.getdragSettingsMovingArea();
        this.$forceUpdate();
        if (!this.databaseDraggingObject.mouseMovingArea) {
          return;
        } else {
          const containerRect =
            this.databaseDraggingObject.scrollContainer.getBoundingClientRect();
          if (
            this.databaseDraggingObject.draggableRect.bottom >
            containerRect.bottom
          ) {
            this.setDatabaseScrollInterval(1, containerRect);
          } else if (
            this.databaseDraggingObject.draggableRect.top <= containerRect.top
          ) {
            this.setDatabaseScrollInterval(-1, containerRect);
          } else {
            this.databaseDraggingObject.scrollInterval = clearInterval(
              this.databaseDraggingObject.scrollInterval
            );
            this.findActiveDropZoneIndex();
          }
        }
        if (
          this.databaseDraggingObject.startingPosition + 15 < e.clientY ||
          this.databaseDraggingObject.startingPosition - 15 > e.clientY
        )
          this.databaseDraggingObject.draggable.style.opacity = 1;
        this.databaseDraggingObject.draggable.style.zIndex = 10;
      }
    },
    setDatabaseScrollInterval(scrollMultiplierValue) {
      if (!this.databaseDraggingObject.scrollInterval)
        this.databaseDraggingObject.scrollInterval = setInterval(() => {
          this.databaseDraggingObject.scrollContainer.scrollTop +=
            scrollMultiplierValue * this.databaseDraggingObject.scrollSpeed;
          if (this.databaseDraggingObject.draggable.style.opacity == 1)
            this.findActiveDropZoneIndex();
        }, 100);
    },
    getdragSettingsMovingArea() {
      if (
        this.databaseDraggingObject.draggableRect.top >=
          this.databaseDraggingObject.draggingArea1Details.rectDetails.top -
            10 &&
        this.databaseDraggingObject.draggableRect.bottom <=
          this.databaseDraggingObject.draggingArea1Details.rectDetails.bottom +
            20
      ) {
        this.databaseDraggingObject.scrollInterval = clearInterval(
          this.databaseDraggingObject.scrollInterval
        );
        this.databaseDraggingObject.scrollContainer =
          document.getElementById('selected');
        return 'selected';
      } else if (
        this.databaseDraggingObject.draggableRect.top >=
          this.databaseDraggingObject.draggingArea2Details.rectDetails.top -
            20 &&
        this.databaseDraggingObject.draggableRect.bottom <=
          this.databaseDraggingObject.draggingArea2Details.rectDetails.bottom +
            10
      ) {
        this.databaseDraggingObject.scrollInterval = clearInterval(
          this.databaseDraggingObject.scrollInterval
        );
        this.databaseDraggingObject.scrollContainer =
          document.getElementById('disselected');
        return 'disselected';
      } else {
        this.databaseDraggingObject.scrollInterval = clearInterval(
          this.databaseDraggingObject.scrollInterval
        );
        this.activeDragOverIdx = null;
        this.$forceUpdate();
        return null;
      }
    },
    findActiveDropZoneIndex() {
      const targetArray = this.getDropingTargetArray();
      targetArray.forEach((target) => {
        const targetRect = target.getBoundingClientRect();
        if (
          (this.getDragingMouseMovingDirection == 'up' ||
            this.getDragingMouseMovingDirection == 'down') &&
          this.getDragableRectTop() <
            this.databaseDraggingObject.startingPosition &&
          // this.databaseDraggingObject.mouseMovingArea == 'selected' &&
          this.getDragableRectTop() >
            targetRect.top - this.getDragableRectHeight() / 2 &&
          this.getDragableRectTop() <
            targetRect.top + this.getDragableRectHeight() / 2
        ) {
          this.activeDragOverIdx = Math.abs(target.id);
        }
        if (
          (this.getDragingMouseMovingDirection == 'down' ||
            this.getDragingMouseMovingDirection == 'up') &&
          this.getDragableRectBottom() >
            this.databaseDraggingObject.startingPosition &&
          // this.databaseDraggingObject.mouseMovingArea == 'selected' &&
          this.getDragableRectBottom() >
            targetRect.bottom - this.getDragableRectHeight() / 2 &&
          this.getDragableRectBottom() <
            targetRect.bottom + this.getDragableRectHeight() / 2
        ) {
          this.activeDragOverIdx = Math.abs(target.id);
        }
      });
    },
    getDragableRectBottom() {
      return this.databaseDraggingObject.draggableRect.bottom;
    },
    getDragableRectTop() {
      return this.databaseDraggingObject.draggableRect.top;
    },
    getDragableRectHeight() {
      return this.databaseDraggingObject.draggableRect.height;
    },
    getDropingTargetArray() {
      if (
        this.databaseDraggingObject.mouseMovingArea == 'selected' &&
        this.getDragableRectTop() < this.databaseDraggingObject.startingPosition
      ) {
        if (this.databaseDraggingObject.selectedArea == 'disselected') {
          const lastDivTag = document.getElementById(
            `selected-${this.selectedItemsLength - 1}`
          );
          if (lastDivTag) {
            const bottomSpanTag = lastDivTag.querySelector(
              '.horizontal-hidden-bottom-line'
            );
            return [
              ...this.databaseDraggingObject.draggingArea1Details
                .horizontalTopTargetLineArray,
              bottomSpanTag,
            ];
          }
        }
        return this.databaseDraggingObject.draggingArea1Details
          .horizontalTopTargetLineArray;
      }
      if (
        this.databaseDraggingObject.mouseMovingArea == 'selected' &&
        this.getDragableRectTop() > this.databaseDraggingObject.startingPosition
      ) {
        return this.databaseDraggingObject.draggingArea1Details
          .horizontalBottomTargetLineArray;
      }
      if (
        this.databaseDraggingObject.mouseMovingArea == 'disselected' &&
        this.getDragableRectTop() < this.databaseDraggingObject.startingPosition
      ) {
        return this.databaseDraggingObject.draggingArea2Details
          .horizontalTopTargetLineArray;
      }
      if (
        this.databaseDraggingObject.mouseMovingArea == 'disselected' &&
        this.getDragableRectTop() > this.databaseDraggingObject.startingPosition
      ) {
        return this.databaseDraggingObject.draggingArea2Details
          .horizontalBottomTargetLineArray;
      }
      return [];
    },
    showScrollbar(event) {
      event.target.classList.add('show-scrollbar');
      debouncer(
        () => {
          event.target.classList.remove('show-scrollbar');
        },
        300,
        this,
        'removeScrollClass'
      );
    },
  },
  computed: {
    appSettings() {
      return Store.state.appSettings;
    },
    user() {
      return Store.state.user;
    },
    settingJson() {
      let customHighlightedItems = JSON.parse(
        JSON.stringify(this.customHighlightedItems)
      );
      if (this.search !== '') {
        customHighlightedItems = this.customHighlightedItems.filter((e) => {
          if (e.label !== undefined) {
            return e.label.toLowerCase().includes(this.search.toLowerCase());
          }
        });
      }
      customHighlightedItems.sort((x, y) => {
        return x.selected === y.selected ? 0 : x.selected ? -1 : 1;
      });
      let selectedTrueItems = customHighlightedItems.filter(
        (e) => e.selected === true
      );
      let selectedFalseItems = customHighlightedItems.filter(
        (e) => e.selected === false
      );

      customHighlightedItems = selectedTrueItems.concat(
        selectedFalseItems.sort((a, b) => a.label.localeCompare(b.label))
      );

      return customHighlightedItems;
    },
    selectedItemsLength() {
      const customHighlightedItems = this.customHighlightedItems.filter((e) => {
        return e.selected;
      });

      return customHighlightedItems.length;
    },
    getHighlightedItems() {
      return this.settingJson.length
        ? this.settingJson.filter((item) => item.selected)
        : [];
    },
    getUnhighlightedItems() {
      return this.settingJson.length
        ? this.settingJson.filter((item) => !item.selected)
        : [];
    },
    getDragingMouseMovingDirection() {
      return this.databaseDraggingObject.mouseMovingDirection;
    },
  },
  mounted() {
    this.databaseDraggingObject.draggingArea1Details.rectDetails =
      this.$refs.customSettingSelectedItems.getBoundingClientRect();
    this.databaseDraggingObject.draggingArea1Details.horizontalTopTargetLineArray =
      this.$refs.customSettingSelectedItems.querySelectorAll(
        '.horizontal-hidden-top-line'
      );
    this.databaseDraggingObject.draggingArea1Details.horizontalBottomTargetLineArray =
      this.$refs.customSettingSelectedItems.querySelectorAll(
        '.horizontal-hidden-bottom-line'
      );
    this.databaseDraggingObject.draggingArea2Details.rectDetails =
      this.$refs.customSettingDisselectedItems.getBoundingClientRect();
    this.databaseDraggingObject.draggingArea2Details.horizontalTopTargetLineArray =
      this.$refs.customSettingDisselectedItems.querySelectorAll(
        '.horizontal-hidden-top-line'
      );
    this.databaseDraggingObject.draggingArea2Details.horizontalBottomTargetLineArray =
      this.$refs.customSettingDisselectedItems.querySelectorAll(
        '.horizontal-hidden-bottom-line'
      );
  },
};
</script>

<style scoped>
/*
@import "https://cdn.jsdelivr.net/npm/pretty-checkbox@3.0/dist/pretty-checkbox.min.css";
*/

.modal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal {
  background: #ffffff;
  border-radius: 0px;
  display: block;
  width: 328px;
  text-align: left;
  font-family: 'Open Sans', open-sans, sans-serif;
  -webkit-font-smoothing: antialiased;
  font-size: 12px;
  line-height: 17px;
  color: #5f697a;
  top: 0;
  position: fixed;
  left: unset;
  top: 0;
  right: 0px;
  border-left: 1px solid #dee3e9;
  min-height: fit-content;
}

.heading {
  padding: 15px 15px 0px;
  text-align: center;
}

.content {
  width: max-content;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  background-color: #fff;
  border-radius: 7px;
  color: #22252b;
  overflow: scroll;
  transition: 0.5s;
  min-height: fit-content;
  height: 100%;
  margin-bottom: 30px;
}

.content.stretch {
  transform: translate(-328px);
  width: 820px;
  transition: 0.5s;
}

.tab {
  display: inline-block;
  /* width: 100%; */
  width: 297px;
  margin-left: 30px;
  min-height: fit-content;
  margin-bottom: 80px;
}

.tab.overview {
  float: left;
  transition: width 0.5s;
  margin-bottom: 0;
}

.tab.details {
  margin-top: -28px;
  margin-right: -12px;
}

.tab.details h2.name {
  background: url(../assets/img/arrow-left-small.svg);
  background-repeat: no-repeat;
  background-size: 12px;
  background-position-y: center;
  background-position-x: left;
  padding-left: 25px;
  cursor: pointer;
}

.tab .link {
  cursor: pointer;
}

.tab.dz-details.h2 .modal {
  background: #ffffff;
  display: block;
  width: 80%;
  text-align: left;
  font-family: 'Open Sans', open-sans, sans-serif;
  -webkit-font-smoothing: antialiased;
  font-size: 12px;
  line-height: 17px;
  color: #5f697a;
  top: 0;
  position: absolute;
  left: unset;
  width: 328px;
  border-left: 1px solid #e2e2e3;
  height: 100%;
  margin-top: 0;
  -webkit-transition: width 0.5s;
  transition: display 0.5s;
  right: 0px;
  float: right;
}
/**/
.heading {
  padding: 15px 15px 0px;
  text-align: center;
}

h1 {
  padding-top: 50px;
  padding-bottom: 8px;
  text-align: center;
  font-size: 33px;
  color: #464d5d;
  margin: 0 0 12px;
  font-weight: 400;
  line-height: 35px;
  text-rendering: optimizelegibility;
  -webkit-font-smoothing: antialiased;
}

h3 {
  color: rgba(85, 93, 109, 0.4);
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  margin-bottom: 10px;
}

h4 {
  color: rgba(85, 93, 109, 0.4);
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  margin-bottom: 0px;
}

input {
  float: left;
  background: #fff;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-right: medium none;
  padding-left: 12px;
  padding-bottom: 15px;
  margin-bottom: 0;
  height: 51px;
  padding-bottom: 14px;
  padding-top: 15px;
  color: #464d5d;
  border: 1px solid #dee3e9;
  border-radius: 2px;
  font-size: 14px;
  font-weight: 400;
  line-height: 19px;
  margin: 0 0 20px;
  -webkit-font-smoothing: antialiased;
  -webkit-box-shadow: none;
  box-shadow: none;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

textarea {
  resize: none;
  float: left;
  background: #fff;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-right: medium none;
  padding-left: 12px;
  padding-bottom: 15px;
  margin-bottom: 0;
  padding-bottom: 14px;
  padding-top: 15px;
  color: #464d5d;
  border: 1px solid #dee3e9;
  border-radius: 2px;
  font-size: 14px;
  font-weight: 400;
  line-height: 19px;
  margin: 0 0 20px;
  -webkit-font-smoothing: antialiased;
  -webkit-box-shadow: none;
  box-shadow: none;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  height: 200px;
  width: 100%;
  overflow: scroll;
}

button {
  border: 1px solid #dee3e9;
  border-radius: 3px 3px 3px 3px;
  width: 30%;
  height: 51px;
  text-transform: uppercase;
  font-weight: 600;
}

button.default {
  color: #464d5d;
  background: #fff;
}

.input-group {
  width: 100%;
}

.imput-group > input {
  width: 70%;
}

.input-group > button {
  min-width: 0;
  width: 30%;
  height: 51px;
  text-transform: uppercase;
  font-weight: 600;
  color: #fff;
  background: #6bbc7c;
  border: 1px solid #5ab36c;
  margin-bottom: 0;
  border-radius: 0 3px 3px 0;
}

.pull-right {
  position: relative;
  z-index: 3;
  transition: right 0.5s;
}

button.btn-green {
  color: white;
  background: #4aae9b;
  border: 1px solid #4aae9b;
  border-radius: 2px;
  margin-left: 9px;
  margin-top: 0;
}

ul.tabsLabels {
  display: inline-block;
  padding: 0;
  margin: 0 0 -1px;
}

.modal ul.tabsLabels li {
  display: inline-block;
  margin: 0 18px;
  list-style: none;
  padding: 0;
  line-height: 14px;
}

.modal:not(.custom) li {
  font-size: 14px;
  line-height: 25px;
  color: #7e8890;
}

.modal ul.tabsLabels a {
  color: #a4abb1;
  font-size: 12px;
  font-weight: 400;
  text-transform: uppercase;
  padding: 21px 7px 22px 33px;
  border-bottom: 2px solid transparent;
  display: block;
  position: relative;
}

a {
  text-decoration: none;
  -webkit-transition: color 0.2s ease, background-color 0.2s ease,
    border-color 0.2s ease;
  -o-transition: color 0.2s ease, background-color 0.2s ease,
    border-color 0.2s ease;
  transition: color 0.2s ease, background-color 0.2s ease,
    border-color 0.2s ease;
  cursor: pointer;
}

a {
  background-color: transparent;
}

.modal ul.tabsLabels a.active {
  border-color: #52b266;
}

.modal ul.tabsLabels a.active,
.modal ul.tabsLabels a:hover {
  color: #464d5d;
  text-decoration: none;
}

/*@media not all, not all, (-webkit-min-device-pixel-ratio: 1.5), not all, (min-resolution: 1.5dppx)*/
.tabsLabels .url {
  background-image: url('');
  background-size: 1293px 1277px;
  background-position: -893px -1109px;
}

.tabsLabels .email {
  background-image: url('');
  background-size: 1293px 1277px;
  background-position: -1100px -1110px;
}

.tabsLabels .mscons {
  background-image: url('');
  background-size: 1293px 1277px;
  background-position: -828px -1175px;
}

.tabsLabels .system {
  background-image: url('');
  background-size: 1293px 1277px;
  background-position: -137px -1178px;
}

p {
  font-weight: 500;
  font-size: 12px;
  line-height: 21px;
  color: #7e8890;
  margin: 25px 0px 25px 0px;
}

.systems {
  background-color: #f9f9fb;
  font-family: 'Open Sans', open-sans, sans-serif;
  -webkit-font-smoothing: antialiased;
  font-size: 12px;
  color: #5f697a;
  line-height: 17px;
  margin: 0;
  display: block;
  overflow: auto;
  width: 100%;
}

.item-wrapper {
  display: block;
  position: relative;
  float: left;
  width: 120px;
  border-radius: 4px;
  background: #fff;
  height: 150px;
  text-align: center;
  margin: 0 39px 43px 0;
  -webkit-box-shadow: 0 1px 2px rgba(43, 59, 93, 0.29);
  box-shadow: 0 1px 2px rgba(43, 59, 93, 0.29);
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.item-wrapper h2 {
  color: #424956;
  font-size: 12px;
  font-weight: 400;
  line-height: inherit;
  margin-top: 0px;
}

.systems-wrapper {
  width: 100%;
  margin: 24px 31px;
}

.img-wrapper {
  width: 100%;
  height: 111px;
}

.systems .logo {
  position: absolute;
  width: 70%;
  position: relative;
  top: 50%;
  transform: translateY(-50%);
}

.pull-right {
  float: right;
  margin-right: 15px;
  margin-top: 15px;
}

.pull-right.default {
  margin-top: 0;
}

.e-mail-params {
  height: 176px;
}

button {
  margin-top: 20px;
}

.form-group {
  width: 100%;
  height: 50px;
  display: flex;
  margin-top: 0px;
  padding-top: 1px;
  padding-bottom: 1px;
  border-bottom: 1px;
  border-bottom-style: solid;
  border-bottom-color: #dee0e4;
}

.form-group .label {
  margin-top: 20px;
  text-transform: none;
}

.form-group input {
  width: 100%;
  border: 0;
  padding-bottom: 14px;
  padding-top: 18px;
}

input:focus {
  outline: none;
}

.tools {
  left: 594px;
  position: relative;
  top: -255px;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  width: 46px;
  height: 199px;
}

.element {
  margin-right: 16px;
}

.tools .element .button {
  background-color: var(--color-black-lighter);
  fill: #fff;
  stroke: #fff;
  width: 60px;
  height: 60px;
  border-radius: var(--circled);
  border: 0;
  -webkit-box-shadow: var(--elevation-medium);
  box-shadow: var(--elevation-low);
  transform: translateZ(0);
  cursor: pointer;
  outline: 0;
  display: flex;
  -webkit-box-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  align-items: center;
  padding: 0;
  transition: all 0.3s ease-out;
}

.tools .element .button.active {
  background-color: #fff;
  fill: var(--color-black-lighter);
  stroke: var(--color-black-lighter);
}

/*.tools .element .button {
  fill: var(--color-black-lighter);
  stroke: var(--color-black-lighter);
  background: #fff;
  -webkit-box-shadow: var(--elevation-low);
  box-shadow: var(--elevation-low);
}*/

.tools .element .button:hover {
  fill: var(--color-black-lighter);
  stroke: var(--color-black-lighter);
  background: #fff;
  -webkit-box-shadow: var(--elevation-high);
  box-shadow: var(--elevation-high);
}

.sum {
  margin-top: 18px;
  margin-left: 18px;
}

.mean {
  margin-top: 11px;
  margin-left: 18px;
}

.product {
  margin-top: 26px;
  margin-left: 0px;
  transform: rotate(45deg);
}

.action {
  margin-left: -5px;
  margin-top: 24px;
}

:root {
  --color-pink: #f36;
  --color-pink-darker: #e81e61;
  --color-blue-lighter: #f5fbff;
  --color-blue: #276ee5;
  --color-blue-darker: #1f53d5;
  --color-green-lighter: #f2fbfa;
  --color-green: #09baa6;
  --color-green-darker: #00a08e;
  --color-yellow-lighter: #fffbf4;
  --color-yellow: #ffb631;
  --color-yellow-darker: #e8a01e;
  --color-red-lighter: #fdf3f5;
  --color-red: #e01e3d;
  --color-red-darker: #c60d2b;
  --color-ink-lightest: #9599a2;
  --color-ink-lighter: #6e7077;
  --color-ink: #22252b;
  --color-ink-darker: #17191d;
  --color-gray-lightest: #f8f8fa;
  --color-gray-lighter: #ebecee;
  --color-gray: #dee0e4;
  --color-gray-darker: #c7cad1;
  --color-black-lighter: #182237;
  --color-black: #15181f;
  --color-white: #fff;
  --elevation-low: 0 0 0 1px rgba(0, 0, 0, 0.05), 0 1px 2px rgba(0, 0, 0, 0.12);
  --elevation-medium: 0 0 0 1px rgba(0, 0, 0, 0.05),
    0 5px 10px rgba(0, 0, 0, 0.15);
  --elevation-high: 0 0 0 1px rgba(0, 0, 0, 0.05),
    0 10px 20px rgba(0, 0, 0, 0.15);
  --rounded: 4px;
  --circled: 50%;
  --pilled: 64px;
}

.tools .element:hover .info-wrapper {
  display: block;
  margin-top: 7px;
  margin-left: -7px;
  z-index: 2;
}

.info-wrapper {
  position: absolute;
  display: none;
  will-change: opacity, visibility;
  transition: visibility 0.2s cubic-bezier(0.2, 0.91, 0.85, 0.96) 0.35s,
    opacity 0.2s cubic-bezier(0.2, 0.91, 0.85, 0.96) 0.35s;
}

.info-wrapper .info {
  font-family: 'Inv Maison Neue', 'Maison Neue', -apple-system,
    BlinkMacSystemFont, 'Open Sans', open-sans, sans-serif;
  font-size: 12px;
  font-weight: 300;
  line-height: 16px;
  letter-spacing: 0.125px;
  white-space: nowrap;
  color: white;
  background: rgb(23, 25, 29);
  border-radius: 4px;
  padding: 8px 16px;
}

.toggle-list-wrapper {
  background-color: #ffff;
  display: flex;
  position: absolute;
  right: 59px;
  -webkit-box-shadow: var(--elevation-high);
  box-shadow: var(--elevation-high);
  max-width: 600px;
  overflow: scroll;
  z-index: 1;
  margin-top: -93px;
}

.toggle-list-wrapper.data-fields {
  border-radius: 3px;
  display: inline-block;
  clear: both;
  padding: 17px 0 17px 0;
  width: 226px;
  margin-top: 127px;
  margin-top: -47px;
}

.toggle-list-wrapper.actions {
  border-radius: 3px;
  display: inline-block;
  clear: both;
  padding: 17px 0 17px 0;
  width: 226px;
  margin-top: -47px;
}

.toggle-list-wrapper .item {
  height: 135px;
  cursor: pointer;
  border-right: 1px solid #dbdee5;
  padding: 8px;
  width: 130px;
  text-align: center;
}

.toggle-list-wrapper.data-fields .item,
.toggle-list-wrapper.actions .item {
  width: 100%;
  text-align: left;
  height: -webkit-fit-content;
  height: -moz-fit-content;
  height: fit-content;
  font-weight: 300;
  margin: 0;
  padding: 0;
}

.toggle-list-wrapper.data-fields .item:hover,
.toggle-list-wrapper.actions .item:hover {
  background: #f0f0f0;
}

.toggle-list-wrapper.data-fields .item .label,
.toggle-list-wrapper.actions .item .label {
  font-weight: 300;
  color: #464d5d;
  margin: 0;
}

.toggle-list-wrapper .item .label {
  overflow: hidden;
  font-size: 12px;
  text-transform: none;
  padding: 0;
  margin: 0;
  margin-top: 11px;
  height: 44px;
  padding-left: 14px;
  padding-right: 14px;
  color: #596377;
}

.pretty {
  line-height: 36px;
}

.logo {
  width: 35px;
  margin-top: 24px;
}

.check-box {
  border-style: solid;
  height: 16px;
  width: 16px;
  position: relative;
  top: -127px;
  border-width: 1px;
  border-color: var(--color-black);
  left: 1px;
  background-color: #ffff;
  transition: all 0.3s ease-out;
  border-radius: 50%;
}

.check-box .icon {
  fill: #ffff;
  zoom: 0.6;
  padding-top: 6px;
  padding-left: 3px;
}

.item.checked .check-box {
  background-color: var(--color-black);
}

.search {
  width: fit-content;
  padding: 0;
  height: 44px;
  margin: 0 0 20px;
  box-sizing: border-box;
}

.search-icon {
  background-image: url(data:image/png;base64,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);
  background-size: 20px;
  overflow: hidden;
  display: block;
  width: 28px;
  height: 21px;
  float: left;
  background-position: 0px 0px;
  background-repeat: no-repeat;
  margin-top: 13px;
  cursor: pointer;
}

.search input {
  border: 0;
  width: 0;
  margin-left: 5px;
  cursor: initial;
  font-size: 13px;
  -webkit-font-smoothing: antialiased;
  font-weight: 300;
  height: auto;
  background: transparent;
  padding: 0;
  -webkit-transition: width 0.3s ease, border-color 0.3s ease-in-out;
  transition: width 0.3s ease, border-color 0.3s ease-in-out;
  margin-bottom: 0;
  height: 100%;
}
.search.active input {
  width: 230px;
}
.search.active {
  border-bottom: solid 2px rgb(255, 51, 102);
}

.attachment {
  overflow: scroll;
  margin-right: 0;
  display: block;
  width: 300px;
  top: -217px;
  position: relative;
  height: 147px;
  margin-left: 0;
  float: right;
  text-align: right;
  cursor: auto;
}

.attachment .item {
  height: 135px;
  cursor: auto;
  padding: 8px;
  width: 75px;
  text-align: center;
  display: inline-block;
  vertical-align: top;
}

.attachment .item .label {
  font-size: 12px;
  text-transform: none;
  padding: 0;
  margin: 0;
  margin-top: 11px;
  height: 44px;
  color: #596377;
}

.no-data {
  display: block;
  width: 100%;
  position: absolute;
}

.options {
  margin: 195px 130px;
  height: 296px;
}

.no-data .option h2 {
  font-size: 24px;
  color: #444f62;
  font-weight: 500;
  font-family: brandon-grotesque, 'Open Sans', open-sans, sans-serif;
  text-rendering: optimizelegibility;
  -webkit-font-smoothing: antialiased;
  text-transform: uppercase;
}

.no-data .option .logo {
  margin-top: 50px;
}

.option img {
  height: 66px;
}

.no-data .option {
  width: 50%;
  display: inline-block;
  height: 296px;
  padding: 0 80px;
  -webkit-box-sizing: border-box; /* Safari/Chrome, other WebKit */
  -moz-box-sizing: border-box; /* Firefox, other Gecko */
  box-sizing: border-box; /* Opera/IE 8+ */
}

.border-reight {
  border-right: 1px solid #d9dde2;
}

.no-data .slp {
  zoom: 1.1;
}
.modal-window {
  position: absolute;
  z-index: 16;
}

.board-body {
  width: 100%;
  min-height: 200px;
  text-align: center;
  color: #5f697a;
  display: block;
  border-top: 1px solid rgb(231, 231, 232);
}

.dragNDropBackGround {
  cursor: pointer;
  background-image: url('');
  background-size: 1100px 1118px;
  background-position: 50% 25px;
  background-repeat: no-repeat;
  overflow: hidden;
  width: 348px;
  display: inline-block;
  text-indent: -9999px;
  font-size: 0;
  line-height: 0;
  opacity: 0.95;
}

.dz-preview {
  float: left;
  display: inline-block;
  position: relative;
  width: 195px;
  height: 185px;
  margin: 0 30px 30px 0;
  border-radius: 4px;
  -webkit-box-shadow: 0 -1px 1px 0 rgba(0, 0, 0, 0.05),
    0 1px 2px 0 rgba(0, 0, 0, 0.2);
  box-shadow: 0 -1px 1px 0 rgba(0, 0, 0, 0.05), 0 1px 2px 0 rgba(0, 0, 0, 0.2);
  -webkit-transition: all 0.2s ease;
  -o-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.dz-message {
  color: #808ca7;
  margin-top: 35px;
}
.dz-message h2 {
  font-size: 43px;
  font-weight: 600;
  color: #808ba7;
  margin-top: 13px;
}
.dz-message p {
  font-size: 18px;
  font-weight: 100;
}
.dz-started .dz-message {
  display: none;
}
.dz-preview:hover {
  transform: translateY(-4px);
  box-shadow: 0 5px 25px 0 rgba(0, 0, 0, 0.3), 0 0 1px 0 rgba(0, 0, 0, 0.2);
}

.dz-preview.loading:hover {
  transform: none;
  box-shadow: none;
}

.dz-preview.checked {
  transform: translateY(-4px);
  -webkit-box-shadow: 0 0 0 2px #1fc281;
  box-shadow: 0 0 0 2px #1fc281;
  -webkit-transition: none;
  -o-transition: none;
  transition: none;
}

.dz-preview.checked .dz-image .data-dz-thumbnail-bg-overlay {
  opacity: 1;
}

.dz-preview .dz-image {
  height: 102px;
  top: 0;
}

.dz-preview .dz-image .data-dz-thumbnail-bg {
  z-index: 1;
  top: 0;
  overflow: hidden;
  border-top-right-radius: 4px;
  border-top-left-radius: 4px;
  left: 0;
  height: 135px;
  width: 100%;
  position: absolute;
}

.dz-preview .dz-image .data-dz-thumbnail-bg.loading {
  z-index: 4000;
  height: 135px;
  border-radius: 4px;
  opacity: 1;
}

.dz-preview .dz-image .data-dz-thumbnail-bg-overlay:hover {
  opacity: 1;
}

.dz-preview .dz-image .data-dz-thumbnail-bg-overlay {
  z-index: 5;
  top: 0;
  overflow: hidden;
  border-radius: 4px;
  left: 0;
  height: 185px;
  width: 100%;
  position: absolute;
  top: 0;
  opacity: 0;
  background-color: rgba(25, 29, 38, 0.85);
  -webkit-transition: opacity 450ms ease-in-out;
  -o-transition: opacity 450ms ease-in-out;
  transition: opacity 450ms ease-in-out;
}

.dz-preview .dz-image .data-dz-thumbnail-bg-overlay.loading {
  height: 185px;
  border-radius: 4px;
  opacity: 1;
}

.dz-preview .dz-image > div {
  width: inherit;
  height: inherit;
  background-size: contain;
}

.dz-preview .dz-image > img {
  width: 100%;
}

.dz-success-mark,
.dz-error-mark,
.dz-remove {
  display: none;
}

.dz-preview .dz-progress {
  opacity: 1;
  height: 16px;
  width: 80px;
  background: hsla(0, 0%, 100%, 0.9);
  transform: scale(1);
  border-radius: 8px;
  overflow: hidden;
}

.dz-preview .dz-details {
  margin: 10px 0 0;
}

.tools {
  position: absolute;
  right: 17px;
  top: 7px;
  z-index: 2;
  border: 0px solid transparent;
  -webkit-transition: visibility 0s ease 450ms, -webkit-box-shadow 0.2s ease;
  -o-transition: visibility 0s ease 450ms, box-shadow 0.2s ease;
  transition: visibility 0s ease 450ms, box-shadow 0.2s ease;
  transition: visibility 0s ease 450ms, box-shadow 0.2s ease,
    -webkit-box-shadow 0.2s ease;
}

/*customize tools for this component */
.tools {
  position: inherit;
  display: flex;
  width: 100%;
  height: -webkit-fit-content;
  height: -moz-fit-content;
  height: fit-content;
  flex-direction: row;
}

.top-bar {
  height: 71px;
  width: 100%;
  margin-top: 25px;
}

.tools li {
  float: left;
  list-style: none;
  cursor: pointer;
  padding: 0;
  margin: 0 0 0 12px;
}

.tools a {
  text-indent: -9999px;
}

a.btn-oval {
  font-family: brandon-grotesque, 'Open Sans', open-sans, sans-serif;
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1px;
  cursor: pointer;
  top: 93px;
  left: 15px;
  width: 166px;
  height: 36px;
  line-height: 36px;
  border: 1px solid rgba(255, 255, 255, 0.25);
  border-radius: 36px;
  color: #fff;
  -webkit-transition: all 0.2s ease-in-out;
  transition: all 0.2s ease-in-out;
  z-index: 2;
  position: absolute;
  text-decoration: none;
  text-align: center;
}

a.btn-oval:hover {
  color: rgba(25, 29, 38, 0.85);
  background-color: white;
}

.zoom {
  width: 170px;
  position: absolute;
  margin-left: 72%;
  margin-top: -354px;
}

.zoom input[type='range'] {
  width: 100%;
}

.tools li > a {
  zoom: 1.2;
  opacity: 0.7;
  background-image: url('');
  background-size: 882px 840px;
  background-position: -868px -268px;
  width: 14px;
  height: 13px;
  background-repeat: no-repeat;
  overflow: hidden;
  display: block;
  -webkit-transition: opacity 0.2s ease-in-out;
  -o-transition: opacity 0.2s ease-in-out;
}

.tools li > a:hover {
  opacity: 1;
}

.tools li.share a {
  background-position: -868px -268px;
}

.tools li.download a {
  background-position: -868px -646px;
}

.tools li.delete a {
  background-position: -129px -759px;
}

ul li {
  line-height: 17px;
}

li {
  display: list-item;
  text-align: -webkit-match-parent;
}

.dz-preview .dz-details h2 {
  font-size: 14px;
  line-height: 20px;
  display: inline-block;
  position: relative;
  padding: 0 30px;
  color: #47506e;
  font-weight: 400;
  margin: 0;
}

.dz-preview .dz-details .rename {
  overflow: hidden;
  -o-text-overflow: ellipsis;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
  box-sizing: border-box;
  margin: 0 0 1px;
}

.dz-preview .dz-details .rename:hover:after {
  background-image: url();
  background-size: 882px 840px;
  background-position: -728px -691px;
  background-repeat: no-repeat;
  overflow: hidden;
  display: block;
  width: 12px;
  height: 12px;
  top: 0;
  right: 0;
  position: absolute;
  content: '';
  margin: 4px 10px 0 0;
}

.dz-preview .dz-image .data-dz-thumbnail-bg-overlay.checked {
  -webkit-box-shadow: 0 0 0 30px #1fc281;
  box-shadow: 0 0 0 30px #1fc281;
  -webkit-transition: none;
  -o-transition: none;
  transition: none;
  opacity: 1;
}

.dz-preview .dz-image .data-dz-thumbnail-bg-overlay div.checker {
  height: 20px;
  width: 20px;
  margin: 14px 0 0 16px;
  -webkit-transition: opacity 0.2s ease;
  -o-transition: opacity 0.2s ease;
  transition: opacity 0.2s ease;
  opacity: 0.7;
  z-index: 1;
  display: block;
  line-height: 21px;
  position: relative;
  zoom: 1;
  position: relative;
}

.dz-preview .dz-image .data-dz-thumbnail-bg-overlay div.checker:hover {
  opacity: 1;
}

.checker input,
.checker input[type='checkbox'] {
  cursor: pointer;
  visibility: visible;
  height: 21px;
  width: 20px;
  display: inline-block;
  background: 0 0;
  opacity: 0;
}

.dz-preview .dz-image .data-dz-thumbnail-bg-overlay div.checker span {
  background-image: url('');
  background-size: 882px 840px;
  background-position: -488px -386px;
  height: 20px;
  width: 20px;
  background-repeat: no-repeat;
  overflow: hidden;
  display: block;
  text-align: center;
}

.dz-preview .dz-image .data-dz-thumbnail-bg-overlay div.checker span.checked {
  background-position: -398px -283px;
}

input[type='checkbox'],
input[type='radio'] {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 0;
  -webkit-font-smoothing: antialiased;
  outline: 0;
  margin: 0 0 9px;
  font-size: 100%;
  vertical-align: middle;
  display: inline-block;
}

.group-actions {
  display: block;
  background: #fff;
  position: fixed;
  bottom: 0;
  box-shadow: 0 -1px 0 rgba(76, 86, 103, 0.2),
    0 -2px 35px rgba(31, 37, 50, 0.14);
  z-index: 1000;
  left: 0;
  width: 100%;
  height: 76px;
  padding: 10px 35px;
  transition: transform 0.3s ease, -webkit-transform 0.3s ease;
  text-align: center;
  float: left;
  clear: both;
}

.group-actions .inner {
  width: 100%;
  text-align: left;
  display: block;
  font-family: 'Open Sans', open-sans, sans-serif;
  -webkit-font-smoothing: antialiased;
  line-height: 22px;
}

.selected-items {
  font-size: 11px;
  border-radius: 100px;
  background: #0fbf00;
  color: #fff;
  padding: 1px 14px 0px;
  margin: 1px 6px 0 0;
  float: left;
  font-weight: 600;
}
.selected-items-label {
  float: left;
  font-size: 12px;
  color: #4a556b;
  font-weight: 600;
  text-transform: uppercase;
  float: left;
  margin: 1px 0 0 10px;
  text-rendering: optimizelegibility;
}
.group-actions .toolbar {
  margin: 3px 0 0 -179px;
  position: absolute;
  left: 50%;
}
.toolbar .list-item {
  float: left;
  margin: 0 15px;
  list-style: none;
  padding: 0;
  display: list-item;
  text-align: -webkit-match-parent;
}

.toolbar .list-item .link {
  cursor: pointer;
  top: 50%;
  display: block;
  text-indent: -9999px;
  opacity: 0.9;
  background-size: 882px 840px;
  width: 16px;
  height: 16px;
  background-repeat: no-repeat;
  display: block;
  overflow: hidden;
}

.toolbar .share .link {
  background-image: url();
  background-position: 0 -759px;
}

.toolbar .delete .link {
  background-image: url();
  background-position: -868px 0;
  width: 14px;
  height: 18px;
}

.toolbar .download .link {
  background-image: url();
  background-position: -800px 0;
  width: 18px;
  height: 18px;
}
.toolbar .more {
  margin-top: 8px;
}

.toolbar .more .link {
  background-image: url();
  background-position: -463px -759px;
  width: 18px;
  height: 4px;
}

.dropdown {
  padding-left: 0px;
  font-size: 14px;
  color: #4a556a;
  font-family: sans-serif;
  -webkit-font-smoothing: unset;
}

.dropdown-menu {
  padding-top: 14px;
  padding-bottom: 14px;
  padding-left: 0px;
  list-style-type: none;
  border: 0;
  border-radius: 2px;
  -webkit-box-shadow: 0 2px 35px rgba(31, 37, 50, 0.14),
    0 0 0 1px rgba(76, 86, 103, 0.2);
  box-shadow: 0 2px 35px rgba(31, 37, 50, 0.14),
    0 0 0 1px rgba(76, 86, 103, 0.2);
  bottom: 10px;
  position: absolute;
  z-index: 100;
  min-width: 195px;
  list-style: none;
  background-color: #fff;
}

.dropdown .list-item {
  margin: 0px;
}

.toolbar .more .dropdown .dropdown-menu .link {
  padding-top: 5px;
  padding-right: 20px;
  padding-bottom: 5px;
  padding-left: 20px;
  width: auto;
  display: list-item;
  list-style: none;
  background: #fff;
  text-indent: 0;
  height: 25px;
  line-height: 18px;
}

.button-wrapper {
  width: 100%;
  display: block;
  padding-left: 80%;
  margin-top: -434px;
  position: absolute;
  height: 60px;
}

.plus-button {
  cursor: pointer;
  display: block;
  color: white;
  border-radius: 50%;
  background-color: rgb(255, 51, 102);
  height: 60px;
  width: 60px;
  line-height: 59px;
  font-size: 30px;
  font-weight: 100;
  box-shadow: 0.5px 0.87px 5px 0 rgba(0, 0, 0, 0.28);
}

.plus-button.clicked {
  transform: rotate(45deg);
}

.plus-button:hover {
  transform: scale(1.1) rotate(0);
}

.plus-button.clicked:hover {
  transform: scale(1.1) rotate(45deg);
}

.plus-btn-options {
  display: block;
  position: absolute;
  margin-top: -360px;
  margin-left: 60%;
  box-shadow: 0.5px 0.87px 5px 0 rgba(0, 0, 0, 0.28);
}

.plus-btn-options .option {
  text-align: center;
  display: inline-block;
  padding: 47px 15px 45px;
  border-right: solid 1px #dbdee5;
  cursor: pointer;
  width: 165px;
}

.file-icon {
  background-image: url('');
  background-size: 882px 840px;

  background-repeat: no-repeat;
  overflow: hidden;
  display: block;

  cursor: pointer;
  margin: 0 auto;
  height: 64px;
}

.plus-btn-options .option h2 {
  font: 600 15px/22px brandon-grotesque, 'Open Sans', open-sans, sans-serif;
  color: #434c5e;
  text-transform: uppercase;
  margin-top: 14px;
  margin-bottom: 0px;
}

.option p {
  font-size: 13px;
  line-height: 22px;
  color: #596377;
  margin: 0;
  padding: 0;
  font-family: inherit;
  text-rendering: optimizelegibility;
  font-family: 'Open Sans', open-sans, sans-serif;
  -webkit-font-smoothing: antialiased;
  font-size: 12px;
  color: #5f697a;
}

.file {
  background-position: -712px 9px;
  width: 38px;
}

.slp {
  background-position: -662px -755px;
  width: 64px;
}

.accessibility {
  left: 64px;
  /*width: 20px !important;*/
}

.progress-icon {
  display: block;
  position: relative;
  left: 127px;
  top: 108px;
  width: 70px;
  height: 70px;
}

.progress-icon:after {
  content: ' ';
  display: block;
  width: 70px;
  height: 70px;
  margin: 1px;
  border-radius: 50%;
  border: 2px solid #fff;
  border-color: #fff transparent #fff transparent;
  animation: progress-icon 1.2s linear infinite;
}

@keyframes progress-icon {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.dz-preview .dz-image .data-dz-thumbnail-bg-overlay div.checker {
  height: 20px;
  width: 20px;
  margin: 14px 0 0 16px;
  -webkit-transition: opacity 0.2s ease;
  -o-transition: opacity 0.2s ease;
  transition: opacity 0.2s ease;
  opacity: 0.7;
  z-index: 1;
  display: block;
  line-height: 21px;
  position: relative;
  zoom: 1;
  position: relative;
}

.dz-preview .dz-image .data-dz-thumbnail-bg-overlay div.checker:hover {
  opacity: 1;
}

.checker input,
.checker input[type='checkbox'] {
  cursor: pointer;
  visibility: visible;
  height: 21px;
  width: 20px;
  display: inline-block;
  background: 0 0;
  opacity: 0;
}

.dz-preview .dz-image .data-dz-thumbnail-bg-overlay div.checker span {
  background-size: 882px 840px;
  background-position: -488px -386px;
  height: 20px;
  width: 20px;
  background-repeat: no-repeat;
  overflow: hidden;
  display: block;
  text-align: center;
}

.dz-preview .dz-image .data-dz-thumbnail-bg-overlay div.checker span.checked {
  background-position: -398px -283px;
}

input[type='checkbox'],
input[type='radio'] {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 0;
  -webkit-font-smoothing: antialiased;
  outline: 0;
  margin: 0 0 9px;
  font-size: 100%;
  vertical-align: middle;
  display: inline-block;
}

.input {
  float: left;
  width: 820px;
  transition: width 0.5s;
}

.series {
  height: 495px;
  overflow: scroll;
  padding-left: 23px;
  padding-top: 23px;
}

.content {
  width: 100%;
  margin: 0;
  padding: 0;
}

.pull-right.pull-further {
  right: 27px;
}

.chart-wrapper {
  width: 294px;
  margin-left: -44px;
}

.modal h2 {
  font-size: 20px !important;
  letter-spacing: 0.125px;
  font-weight: 600 !important;
  font-family: 'Inv Eina 03', 'Eina 03', -apple-system, BlinkMacSystemFont,
    'Open Sans', open-sans, sans-serif;
  line-height: 40px;
  color: rgb(34, 37, 43);
  margin-top: 54px;
  margin-bottom: 10px;
}

.modal h3 {
  font-family: 'Inv Maison Neue', 'Maison Neue', -apple-system,
    BlinkMacSystemFont, 'Open Sans', open-sans, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 39px;
  letter-spacing: 0.125px;
  color: rgb(34, 37, 43);
  margin-top: 34px;
  padding-bottom: 6px;
  font-weight: 700 !important;
  text-transform: none;
  margin-bottom: 0px;
}

.content .list .item {
  display: flex;
  border-top: 1px solid #dee0e4;
  line-height: 39px;
  height: 39px;
  font-size: 14px;
  cursor: pointer;
}

.content .tab.overview .list .item:hover {
  background: url(../assets/img/arrow-right-small.svg);
  background-repeat: no-repeat;
  background-size: 12px;
  background-position-y: center;
  background-position-x: right;
}

.content .list .item .key {
  display: inline;
  font-weight: 300;
}
.content .list .item .value {
  display: inline;
  margin-bottom: 8px;
  text-align: right;
  width: 20%;
  font-weight: 300;
}

.content .tab.details .list .item .key {
  display: inline;
  font-weight: 300;
  width: 100%;
  cursor: pointer;
}
.content .tab.details .list .item .value {
  display: inline;
  margin-bottom: 8px;
  text-align: right;
  width: 20%;
  font-weight: 300;
  cursor: pointer;
}

.block {
  width: 268px;
}

.radio-wrapper {
  width: 100%;
  display: block;
}

.radioOption {
  display: inline-block;
  width: fit-content;
  height: 40px;
  margin-right: 22px;
}

.radioOption input {
  float: none;
  width: 20px;
  height: 40px;
  margin-bottom: 0;
  cursor: pointer;
}

.radioOption label {
  line-height: 31px;
  float: right;
  padding: 0;
  margin-bottom: 0.3em;
  margin-right: 0;
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
  margin-left: 12px;
  height: 31px;
}

.block p,
span {
  line-height: 21px;
  font-size: 14px;
  font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica,
    Arial, sans-serif, Inv Maison Neue, Apple Color Emoji, Segoe UI Emoji,
    Segoe UI Symbol;
  font-weight: 400;
  color: #000;
  background: #fff;
  -webkit-font-smoothing: antialiased;
}

.block a {
  font-weight: 300;
  letter-spacing: 0.18px;
  text-decoration: underline;
  line-height: 39px;
  height: 39px;
  font-size: 14px;
  cursor: pointer;
  margin-top: 50px;
}

.custom-checklist {
  position: relative;
  padding: 12px 0;
}

.custom-checklist input[type='checkbox'] {
  position: absolute;
  opacity: 0;
  margin: 0;
  height: 33px;
  display: block;
  float: none;
  line-height: 0;
  border: none;
  cursor: pointer;
  width: 100%;
  z-index: 1;
}

.custom-checklist input[type='checkbox'] + label span {
  position: absolute;
  right: 0;
  top: 0;
  width: 40px;
  height: 40px;
  background: #fff;
  border-radius: 3px;
  font-family: 'Font Awesome 5 Free';
  font-weight: 900;
  font-size: 15px;
  color: #555353;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-right: 10px;
  z-index: 1;
}

.custom-checklist input[type='checkbox'] + label {
  display: block;
  cursor: pointer;
  margin-bottom: 0;
  font-size: 15px;
  width: calc(100% - 35px);
}
.custom-checklist input[type='checkbox'] + label span:hover i:before {
  content: '\f06e';
}
.custom-checklist input[type='checkbox']:checked + label span:hover i:before {
  content: '\f070';
}

/* .custom-checklist input[type="checkbox"] + label:after {
  content: "";
  position: absolute;
  top: 11px;
  right: 21px;
  height: 7px;
  width: 4px;
  border-bottom: 2px solid white;
  border-right: 2px solid white;
  transform: rotate(45deg);
  z-index: 1;
  opacity: 0;
  visibility: hidden;
}

.custom-checklist input[type="checkbox"]:checked + label:after {
  opacity: 1;
  visibility: visible;
} */

.filter-subtitle {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
}
.highlighted-item-filter {
  padding: 0 0;
  background: #fff;
}
.filter-item {
  padding: 0 0;
  padding-right: 0;
  box-sizing: border-box;
  width: calc(100% - 30px);
  max-width: 268px;
  height: calc(100% - 110px);
}
.pl-20 {
  padding-left: 20px;
}
.ml-20 {
  margin-left: 20px;
}
/* .fancy-scroll::-webkit-scrollbar {
  width: 3px !important;
  height: 5px;
}

.fancy-scroll::-webkit-scrollbar-track {
  background: #d8d8d8;
  border-radius: 5px;
}

.fancy-scroll::-webkit-scrollbar-thumb {
  background: #000;
  border-radius: 5px;
  cursor: pointer;
}

.fancy-scroll::-webkit-scrollbar-thumb:hover {
  background: #000;
} */
.dropzone-line {
  position: relative;
  padding-left: 20px;
}

.dropzone-line .drag-icon {
  position: absolute;
  left: 0;
  top: 13.5px;
  cursor: pointer;
  z-index: 1;
}
.dropzone-line {
  border-top: 1px solid #d1d1d1;
}

.bottom {
  border-bottom-width: 2px;
  border-bottom-color: #000;
  border-bottom-style: solid;
}
.search-box {
  display: inline-block;
  width: 268px;
}

.search-box input {
  padding: 10px 15px;
  margin-bottom: 20px;
  height: 40px;
  background: #f6f6f6;
  border-color: #f6f6f6;
  width: 100%;
}
.highlighted-item-filter .filter-item h2 {
  margin-bottom: 10px !important;
  font-size: 14px !important;
  line-height: 20px;
  margin-top: 0;
}

.dropzone-line:last-child {
  border-bottom: 1px solid #d1d1d1;
}
.highlighted-item-filter {
  height: calc(100vh - 170px);
}

.filter-item-dropdown.fancy-scroll {
  height: calc(100% - 30px);
  overflow: auto;
}

.filter-item > div {
  height: 50%;
  margin-bottom: 30px;
}
span.horizontal-hidden-top-line {
  position: absolute;
  display: block;
  width: 100%;
  height: 2px;
  top: 0;
  background: transparent;
  left: 0;
  z-index: 9;
}

span.horizontal-hidden-bottom-line {
  position: absolute;
  display: block;
  width: 100%;
  height: 2px;
  bottom: 0;
  background: transparent;
  left: 0;
  z-index: 9;
}

span.horizontal-hidden-bottom-line.dragActive,
span.horizontal-hidden-top-line.dragActive {
  background: black;
}
.custom-database-settings-wrapper {
  overflow-y: hidden;
}
.custom-database-settings-wrapper .database-setting-title {
  margin-top: 40px !important;
}

.custom-database-settings-wrapper .custom-checkbox-label {
  min-height: 16px;
}
</style>
